var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitsImportant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.6,
    height: 14.64,
    viewBox: "0 0 2.6 14.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41463",
    "data-name": "Caminho 41463",
    d: "M-3.78-3.28a45.126,45.126,0,0,1-.24-5.06v-6.04h1.86v6.04q0,.78-.01,1.44t-.04,1.26q-.03.6-.08,1.18t-.13,1.18ZM-4.4-1a1.212,1.212,0,0,1,.38-.92,1.314,1.314,0,0,1,.94-.36,1.255,1.255,0,0,1,.91.36A1.228,1.228,0,0,1-1.8-1a1.2,1.2,0,0,1-.37.9,1.255,1.255,0,0,1-.91.36A1.324,1.324,0,0,1-4.01-.1,1.174,1.174,0,0,1-4.4-1Z",
    transform: "translate(4.4 14.38)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsImportant);
export default __webpack_public_path__ + "static/media/benefits-important.3bf46df604cc69045a7e084195c483e7.svg";
export { ForwardRef as ReactComponent };